module.exports = __webpack_public_path__ + "img/new-relic.b4cb1a68.png";